/**
 * @generated SignedSource<<5e5e20a65fa473102e66633a871353f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateRelatedTemplatesContentfulRelayFragment$data = {
  readonly relatedTemplatesCollection: {
    readonly items: ReadonlyArray<{
      readonly sys: {
        readonly id: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"templateCardContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateRelatedTemplatesContentfulRelayFragment";
};
export type templateRelatedTemplatesContentfulRelayFragment$key = {
  readonly " $data"?: templateRelatedTemplatesContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateRelatedTemplatesContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateRelatedTemplatesContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateRelatedTemplatesCollection",
      "kind": "LinkedField",
      "name": "relatedTemplatesCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductTemplate",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Sys",
              "kind": "LinkedField",
              "name": "sys",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "templateCardContentfulRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "6fdcb09848f43d30eb54f40624d96941";

export default node;
